import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { Clickable } from 'src/components/clickable';

import { GoToStoreButton } from '../go-to-store-button';
import { StockPriceInfo } from '../stock-price-info';
import { StoreInfoColumn } from '../store-info-column';

import { getContainerProps } from '../../utils';

import { AlternativePrice } from 'src/types';
import { ITableLinkProps } from '../../types';

import {
  StyledActionArea,
  StyledEndColumn,
  StyledMiddleColumn,
  StyledProductName,
  StyledRow,
  StyledProductNameColumn,
  StyledTopMiddleRow,
} from './styles';

type Props = {
  alternativeOffer?: AlternativePrice;
  tableLinkProps: ITableLinkProps;
};

export const FeaturedColumns: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const { alternativeOffer, tableLinkProps } = props;

  const { offer, forceMobileView, showExpandButton } = usePriceRowContext();

  const isAlternative = Boolean(alternativeOffer);
  const name = alternativeOffer?.name || offer.name;

  const externalUri = isAlternative
    ? alternativeOffer?.externalUri
    : offer.externalUri;

  const containerProps = getContainerProps(
    name || '',
    true,
    tableLinkProps.onClick,
    externalUri
  );

  return (
    <StyledActionArea
      container={Clickable}
      containerProps={containerProps}
      style={{ paddingLeft: showExpandButton ? 0 : 48 }}
    >
      <StyledRow>
        {!isAlternative && <StoreInfoColumn />}
        <StyledMiddleColumn $featured>
          <StyledTopMiddleRow $featured $forceMobileView={forceMobileView}>
            <StyledProductNameColumn
              $forceMobileView={Boolean(forceMobileView)}
            >
              <StyledProductName
                $featured
                $forceMobileView={forceMobileView}
                $isAlternative={isAlternative}
              >
                {name}
              </StyledProductName>
            </StyledProductNameColumn>
            <StockPriceInfo alternativeOffer={alternativeOffer} />
          </StyledTopMiddleRow>
        </StyledMiddleColumn>
        <StyledEndColumn $forceMobileView={forceMobileView} $featured>
          <GoToStoreButton />
        </StyledEndColumn>
      </StyledRow>
    </StyledActionArea>
  );
};
